var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4161_13047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.81329 16.2534C12.9593 16.2163 16.2902 12.8252 16.2531 8.6792C16.2159 4.53321 12.8249 1.2023 8.67886 1.23942C4.53287 1.27655 1.20197 4.66764 1.23909 8.81364C1.27621 12.9596 4.6673 16.2905 8.81329 16.2534Z",
    stroke: "#C3C3C3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2477 3.46948C15.3328 3.78453 16.3329 4.34044 17.1733 5.09578C18.0137 5.85112 18.6728 6.78641 19.1014 7.83193C19.53 8.87745 19.7171 10.0062 19.6487 11.1341C19.5804 12.262 19.2583 13.3599 18.7066 14.346C18.1548 15.3321 17.3876 16.181 16.4622 16.8293C15.5367 17.4776 14.4768 17.9087 13.3616 18.0904C12.2463 18.2721 11.1044 18.1997 10.021 17.8786C8.93764 17.5576 7.94069 16.9961 7.10449 16.2361",
    stroke: "#C3C3C3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82837 7.10718L6.75847 11.7413L8.50986 7.10718L10.3856 11.7413L12.1092 7.10718",
    stroke: "#C3C3C3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13086 9.09985H12.8068",
    stroke: "#C3C3C3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4161_13047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.e494305ae31f5c63ff59fa56ed742f23.svg";
export { ForwardRef as ReactComponent };